module.exports = __webpack_public_path__ + "assets/img/SISTER2.a5bbe445.png";